/**
 * Вычисляет границы отображения шкалы на основе пороговых значений.
 *
 * Формула:
 *   maxAll = max(high_warning, high_error, 100)
 *   minAll = min(low_warning, low_error, 0)
 *   displayMin = minAll - 1.1 * (maxAll - minAll)
 *   displayMax = maxAll + 1.1 * (maxAll - minAll)
 * @param {object} params - Пороговые значения
 * @param {number} [params.warningLower] - Нижняя граница предупреждения
 * @param {number} [params.warningUpper] - Верхняя граница предупреждения
 * @param {number} [params.errorLower]   - Нижняя граница тревоги
 * @param {number} [params.errorUpper]   - Верхняя граница тревоги
 * @returns {{ displayMin: number, displayMax: number }} Границы отображения шкалы
 */
export default function computeScaleBounds({ warningLower, warningUpper, errorLower, errorUpper }) {
  const maxAll = Math.max(
    warningUpper ?? -Infinity,
    errorUpper ?? -Infinity,
    100,
  );
  const minAll = Math.min(
    warningLower ?? Infinity,
    errorLower ?? Infinity,
    0,
  );
  const range = maxAll - minAll || 1;

  return {
    displayMin: minAll - 0.1 * range,
    displayMax: maxAll + 0.1 * range,
  };
}
